export default function isAllowedReferrerOrigin(url) {
    let parsed

    try {
        parsed = new URL(url)
    } catch (e) {
        return false
    }

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false

    const {hostname} = parsed

    if (hostname === 'localhost') return true
    if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true
    if (hostname === 'merchize.com' || hostname.endsWith('.merchize.com')) return true

    return false
}
